import _123 from 'assets/images/aboutUsPage/partnership/123.png'
import Amur from 'assets/images/aboutUsPage/partnership/Amur.png'
import Atlantic from 'assets/images/aboutUsPage/partnership/Atlantic.png'
import Bazelevs from 'assets/images/aboutUsPage/partnership/Bazelevs.png'
import DK from 'assets/images/aboutUsPage/partnership/DK.png'
import forece_media from 'assets/images/aboutUsPage/partnership/forece_media.png'
import Fox from 'assets/images/aboutUsPage/partnership/Fox.png'
import HIT from 'assets/images/aboutUsPage/partnership/HIT.png'
import ID from 'assets/images/aboutUsPage/partnership/ID.png'
import Kinomir from 'assets/images/aboutUsPage/partnership/Kinomir.png'
import Kinopolis from 'assets/images/aboutUsPage/partnership/Kinopolis.png'
import Kit from 'assets/images/aboutUsPage/partnership/Kit.png'
import Kitchen from 'assets/images/aboutUsPage/partnership/Kitchen.png'
import Kulik from 'assets/images/aboutUsPage/partnership/Kulik.png'
import Legio from 'assets/images/aboutUsPage/partnership/Legio.png'
import Look from 'assets/images/aboutUsPage/partnership/Look.png'
import MARS from 'assets/images/aboutUsPage/partnership/MARS.png'
import MediaSlovo from 'assets/images/aboutUsPage/partnership/MediaSlovo.png'
import Metrafilms from 'assets/images/aboutUsPage/partnership/Metrafilms.png'
import Ostrov from 'assets/images/aboutUsPage/partnership/Ostrov.png'
import Pinery from 'assets/images/aboutUsPage/partnership/Pinery.png'
import QS from 'assets/images/aboutUsPage/partnership/QS.png'
import Rmedia from 'assets/images/aboutUsPage/partnership/R-media.png'
import RBC from 'assets/images/aboutUsPage/partnership/RBC.png'
import Red from 'assets/images/aboutUsPage/partnership/Red.png'
import Sreda from 'assets/images/aboutUsPage/partnership/Sreda.png'

export const items = [
  { src: RBC, alt: 'RBC' },
  { src: Sreda, alt: 'Sreda' },
  { src: QS, alt: 'QS' },
  { src: Fox, alt: 'Fox' },
  { src: DK, alt: 'DK' },
  { src: Kit, alt: 'Kit' },
  { src: Legio, alt: 'Legio' },
  { src: HIT, alt: 'HIT' },
  { src: Kulik, alt: 'Kulik' },
  { src: _123, alt: '123' },
  { src: MARS, alt: 'MARS' },
  { src: forece_media, alt: 'forece_media' },
  { src: Amur, alt: 'Amur' },
  { src: ID, alt: 'ID' },
  { src: Atlantic, alt: 'Atlantic' },
  { src: Kinomir, alt: 'Kinomir' },
  { src: Pinery, alt: 'Pinery' },
  { src: Red, alt: 'Red' },
  { src: Look, alt: 'Look' },
  { src: Metrafilms, alt: 'Metrafilms' },
  { src: Kinopolis, alt: 'Kinopolis' },
  { src: Kitchen, alt: 'Kitchen' },
  { src: Ostrov, alt: 'Ostrov' },
  { src: Bazelevs, alt: 'Bazelevs' },
  { src: MediaSlovo, alt: 'MediaSlovo' },
  { src: Rmedia, alt: 'Rmedia' },
]
